<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  <div (click)="showMe = !showMe" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
    <h3 class="zero-text p-base-med">{{ 'user-self-service.security.headline' | transloco }}</h3>
    <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
  </div>
</div>

<div class="row opacity-container" [class.active]="showMe">
  <div class="col-12 mt-3">
    <div class="row">
      @if (appAuthEnabled$ | async) {
        <div class="p-0 col-12">
          <self-service-apptan-admin />
        </div>
        <div class="col-6 d-none d-md-block"></div>
      }
    </div>
    <div class="row mt-2 align-items-center">
      <div class="pl-0 col-11">
        <h4 class="zero-text p-small-bold">{{ 'user-self-service.security.sms-tan-number' | transloco }}</h4>
      </div>
      <div class="col-1 text-right pr-0">
        <button
          class="btn btn-link pr-0"
          (click)="changeMobile()"
          [ngbTooltip]="'user-self-service.security.change-number' | transloco"
          [openDelay]="500"
          placement="bottom"
          [hidden]="state !== 'init'"
        >
          <web-design-system-icon name="edit" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 pl-0">
        <div class="d-flex align-items-center">
          <span>{{ currentUser?.mobilenr }}</span>
          <span
            class="icon icon-18 ml-2"
            [ngClass]="currentUser?.mobilenr && currentUser?.mobilenrVerified === 'true' ? 'haken' : 'cross'"
          ></span>
        </div>
      </div>
    </div>

    @if (state === 'inputNewMobile') {
      <form (ngSubmit)="newMobile(f1)" #f1="ngForm">
        <div class="row mt-4">
          <div class="col-12 col-md-6 d-flex flex-wrap mr-3 pl-0">
            <div class="input-group-material" [class.input-group-material--error]="cMobileNrInput.errors && cMobileNrInput.touched">
              <web-components-phone-input
                [(ngModel)]="newMobileNr"
                #cMobileNrInput="ngModel"
                name="phone_input"
                id="phone_input"
                #phoneInputComponent
                [class.empty]="!!phoneInputComponent.isEmpty"
                required
              />
              <div class="input-group-material-icon-state"></div>
              <label for="phone_input">{{ 'user-self-service.security.new-number' | transloco }}</label>
              <div class="input-group-material-message">
                @if (!cMobileNrInput.value || cMobileNrInput.valid) {
                  &nbsp;
                }
                @if (cMobileNrInput.getError('phoneInput') === 'invalid') {
                  {{ 'user-self-service.security.invalid-new-number' | transloco }}
                }
                @if (cMobileNrInput.getError('phoneInput') === 'notmobile') {
                  {{ 'user-self-service.security.not-mobile-new-number' | transloco }}
                }
              </div>
            </div>
            <div class="d-flex align-items-center">
              <web-design-system-button size="small" class="mr-4" [disabled]="!f1.valid" [isSubmit]="true">
                {{ 'user-self-service.security.submit-new-number' | transloco }}
              </web-design-system-button>
              <a class="link link-secondary font-size-smaller1 cursor-pointer" (click)="cancelMobile()">
                {{ 'user-self-service.security.cancel-new-number' | transloco }}
              </a>
            </div>
          </div>
        </div>
      </form>
    }
    @if (state === 'tanMobile') {
      <div class="row mt-3">
        <div class="pl-0 col-12">
          <p [innerHTML]="'user-self-service.security.auth-hint' | transloco: { newMobileNr }"></p>
          @if (!authenticationMode) {
            <div class="row">
              <div class="col col-md-6 d-flex align-items-center">
                <web-design-system-button size="small" (click)="startChangeMobileNr()" class="mr-4">
                  {{ 'user-self-service.security.auth-hint-accept' | transloco }}
                </web-design-system-button>
                <a (click)="cancelMobile()" class="link link-secondary font-size-smaller1 cursor-pointer">
                  {{ 'user-self-service.security.auth-hint-cancel' | transloco }}
                </a>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (authenticationMode) {
      <div class="row">
        <div class="pl-0 col-12 col-md-6">
          <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
        </div>
      </div>
    }
    @if (state === 'verifiyNewMobileNr') {
      <div class="row mt-3">
        <div class="pl-0 col-12">
          <p [innerHTML]="'user-self-service.security.auth-success' | transloco: { newMobileNr }"></p>
        </div>
      </div>

      @if (codeRequested) {
        <form (ngSubmit)="confirmMobileCase(f)" #f="ngForm">
          <div class="row mt-3">
            <div class="pl-0 col-auto">
              <div class="input-group-material" [class.input-group-material--error]="tanInputVar.touched && tanInputVar.invalid">
                <input
                  type="text"
                  required
                  [(ngModel)]="verificationCode"
                  name="tanInput"
                  #tanInputVar="ngModel"
                  [class.empty]="!tanInputVar.value"
                  pattern="[0-9]{6}"
                  maxlength="6"
                  id="tanInput"
                />
                <div class="input-group-material-icon-state"></div>
                <label for="tanInput">{{ 'user-self-service.security.code' | transloco }}</label>
                <div class="input-group-material-message">
                  @if (!(tanInputVar.touched && tanInputVar.invalid)) {
                    &nbsp;
                  }
                  @if (tanInputVar.touched && tanInputVar.invalid) {
                    {{ 'user-self-service.security.invalid-code' | transloco }}
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="pl-0 col-12 col-md-6 d-flex align-items-center">
              <web-design-system-button [disabled]="!f.valid" size="small" class="mr-4" [isSubmit]="true">
                {{ 'user-self-service.security.code-submit' | transloco }}
              </web-design-system-button>
              <a (click)="cancelMobile()" class="link link-secondary font-size-smaller1 cursor-pointer">{{
                'user-self-service.security.code-cancel' | transloco
              }}</a>
            </div>
          </div>
        </form>
        <div class="row mt-2">
          <div class="pl-0 col-12">
            {{ 'user-self-service.security.code-not-received' | transloco }}
            <a class="link link-secondary text-default cursor-pointer" (click)="resendTanMobile()">{{
              'user-self-service.security.code-retry' | transloco
            }}</a>
          </div>
        </div>
      }
    }
    <div class="row">
      <div class="pl-0 col-12">
        <web-components-user-messages />
      </div>
    </div>
    <div class="row mt-3">
      <div class="pl-0 col-md-6 col-12">
        <h4 class="mb-2 zero-text p-small-bold">{{ 'user-self-service.security.login' | transloco }}</h4>
        {{ 'user-self-service.security.email' | transloco }}<br />
        <div class="d-flex align-items-center">
          <span>{{ currentUser?.email }}</span>
          <span class="icon icon-18 ml-2" [ngClass]="currentUser?.emailVerified === 'true' ? 'haken' : 'cross'"></span>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="pl-0 col-12">
        <h4 class="mb-2 zero-text p-small-bold">{{ 'user-self-service.security.password' | transloco }}</h4>
        {{ 'user-self-service.security.password-hint' | transloco }}
      </div>
    </div>
  </div>
</div>
